import Icon, { IconProps } from './Icon';

type SpinningIconProps = IconProps & {
  speed?: string;
};

export const SpinningIcon = ({ speed = '1s', ...props }: SpinningIconProps) => {
  return (
    <div
      style={{
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        animation: `spin ${speed} linear infinite`
      }}
    >
      <Icon {...props} />
    </div>
  );
};
